import { mapGetters, mapActions } from 'vuex'

export const signingWizardActions = {
  ...mapActions('signingWizardStore', [
    'openWizard',
    'closeWizard',
    'goNext',
    'goBack',
    'setTokenWizard',
    'setDocumentWizard',
    'setSignerWizard',
    'getDocumentMetadata',
    'signDocument',
    'finishWizard',
    'setOnSuccessSigning'
  ])
}

export const signingWizardData = {
  ...mapGetters('signingWizardStore', [
    'dialogWizard',
    'steps',
    'wizardLength',
    'canGoNext',
    'wizardStep',
    'tokenWizard',
    'documentWizard',
    'signerWizard',
    'dialogFinish',
    'onSuccessSigning'
  ])
}
